import { render, staticRenderFns } from "./goods-det.vue?vue&type=template&id=0f84d69d&scoped=true"
import script from "./goods-det.vue?vue&type=script&lang=js"
export * from "./goods-det.vue?vue&type=script&lang=js"
import style0 from "./goods-det.vue?vue&type=style&index=0&id=0f84d69d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f84d69d",
  null
  
)

export default component.exports